import React, { useEffect } from "react";
const AlbumIcon = require("../styles/images/GreenAlbum.svg");
import Breadcrumbs from "./Breadcrumbs";

interface NoAlbumsProps {
  showNewAlbumModal: () => void;
  canCreateAlbums?: boolean;
}

const NoAlbums = ({ showNewAlbumModal, canCreateAlbums }: NoAlbumsProps) => {
  useEffect(() => {
    const contentViewElement = document.getElementById("content-view");
    if (contentViewElement) {
      contentViewElement.scrollIntoView();
      window.scrollBy(0, -150);
    }
  }, []);

  return (
    <div className="ws-album-list">
      <Breadcrumbs viewType="NoAlbum" />
      <div className="geo-display-center">
        <div className="ws-no-items-container">
          <div className="ws-white-circle">
            <img
              src={AlbumIcon}
              alt="No albums"
              className="ws-no-items-image"
            />
          </div>
          <h2 className="ws-no-items-title">No albums here</h2>
          <p className="ws-no-items-text">Create albums to upload photos.</p>
          {canCreateAlbums && (
            <div
              className="geo-btn geo-btn--secondary geo-btn--caps"
              onClick={showNewAlbumModal}
            >
              Create an Album
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoAlbums;
